import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, CalendarCheck, ClipboardList, Bot, Mail, LogOut, Menu, X, UserCheck, Target } from 'lucide-react';

const allNavItems = [
  { name: 'Dashboard', path: '/intranet', icon: LayoutDashboard, roles: ['admin', 'formateur'] },
  { name: 'Élèves', path: '/intranet/eleves', icon: Users, roles: ['admin', 'formateur'] },
  { name: 'Présences', path: '/intranet/presences', icon: UserCheck, roles: ['admin', 'formateur'] },
  { name: 'Séances', path: '/intranet/seances', icon: CalendarCheck, roles: ['admin', 'formateur'] },
  { name: 'Objectifs', path: '/intranet/objectifs', icon: Target, roles: ['admin', 'formateur'] },
  { name: 'Inscriptions', path: '/intranet/inscriptions', icon: ClipboardList, roles: ['admin', 'formateur'] },
  { name: 'Robots', path: '/intranet/robots', icon: Bot, roles: ['admin'] },
  { name: 'Messages', path: '/intranet/messages', icon: Mail, roles: ['admin'] },
];

export const IntranetLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const role = user.role || 'formateur';
  const navItems = allNavItems.filter(item => item.roles.includes(role));

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const SidebarContent = () => (
    <>
      <div className="p-5 border-b border-slate-700">
        <Link to="/" className="flex items-center space-x-2">
          <img src="https://customer-assets.emergentagent.com/job_techkids-learn-1/artifacts/2efozgua_471419268_122203530860204093_7119326466186742520_n-2.jpg" alt="Logo" className="h-9 w-auto" />
          <div>
            <span className="font-heading text-sm font-extrabold text-white block leading-tight">Ludotech</span>
            <span className="text-[10px] font-bold text-[#F97316] tracking-wider uppercase">Intranet</span>
          </div>
        </Link>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path} onClick={() => setSideOpen(false)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                active ? 'bg-[#1B6FE3] text-white' : 'text-slate-400 hover:text-white hover:bg-white/5'
              }`}>
              <Icon size={18} />
              {item.name}
            </Link>
          );
        })}
      </nav>
      <div className="p-3 border-t border-slate-700">
        <div className="px-3 py-2 mb-2">
          <p className="text-xs font-bold text-white truncate">{user.name || 'Utilisateur'}</p>
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">{role === 'admin' ? 'Administrateur' : 'Formateur'}</p>
        </div>
        <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-400 hover:text-red-400 hover:bg-white/5 w-full transition-all">
          <LogOut size={18} />
          Déconnexion
        </button>
      </div>
    </>
  );

  return (
    <div className="flex h-screen bg-slate-100">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-60 bg-[#0F2B4C] flex-col flex-shrink-0">
        <SidebarContent />
      </aside>

      {/* Mobile sidebar overlay */}
      {sideOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setSideOpen(false)} />
          <aside className="absolute left-0 top-0 bottom-0 w-60 bg-[#0F2B4C] flex flex-col z-10">
            <SidebarContent />
          </aside>
        </div>
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-slate-200 px-4 md:px-6 py-3 flex items-center justify-between flex-shrink-0">
          <button onClick={() => setSideOpen(true)} className="lg:hidden p-2 rounded-lg hover:bg-slate-100">
            <Menu size={20} />
          </button>
          <h1 className="font-heading text-lg font-extrabold text-slate-800">
            {navItems.find(n => n.path === location.pathname)?.name || 'Intranet'}
          </h1>
          <Link to="/" className="text-sm text-[#1B6FE3] font-semibold hover:underline">Voir le site</Link>
        </header>
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default IntranetLayout;
